// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"
import { getStorage } from "firebase/storage"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCpD4x8PR7VwUs5ndaDLwJE4LlxLqkdInE",
  authDomain: "emotion-thought.firebaseapp.com",
  databaseURL: "https://emotion-thought-default-rtdb.firebaseio.com",
  projectId: "emotion-thought",
  storageBucket: "emotion-thought.appspot.com",
  messagingSenderId: "2179311089",
  appId: "1:2179311089:web:0788c577a59ea3c8381050",
  measurementId: "G-GX2HGP9B1V"
};


// Initialize Firebase
const fire = initializeApp(firebaseConfig);
const database = getDatabase(fire)
const fireStorage = getStorage(fire)

export {database, fireStorage, fire as default}